/**
 * Grefi Hero — works on .grefi-hero root (div, not custom element)
 */
(function () {
  function init(root) {
    if (!root || root.dataset.grefiHeroReady === 'true') return;
    root.dataset.grefiHeroReady = 'true';

    const slides = [...root.querySelectorAll('.grefi-hero__slide')];
    const dots = [...root.querySelectorAll('.grefi-hero__dot')];
    const prevBtn = root.querySelector('[data-grefi-hero-prev]');
    const nextBtn = root.querySelector('[data-grefi-hero-next]');
    let current = 0;
    const autoplayMs = parseInt(root.dataset.autoplay, 10) || 0;
    let timer = null;
    let touchStartX = 0;
    let touchDeltaX = 0;

    if (slides.length <= 1) return;

    const go = (index) => {
      slides[current]?.classList.remove('is-active');
      dots[current]?.classList.remove('is-active');
      dots[current]?.setAttribute('aria-selected', 'false');
      if (slides[current]) slides[current].setAttribute('aria-hidden', 'true');

      current = (index + slides.length) % slides.length;

      slides[current]?.classList.add('is-active');
      dots[current]?.classList.add('is-active');
      dots[current]?.setAttribute('aria-selected', 'true');
      if (slides[current]) slides[current].setAttribute('aria-hidden', 'false');

      pause();
      play();
    };

    const play = () => {
      if (!autoplayMs || slides.length <= 1) return;
      timer = setInterval(() => go(current + 1), autoplayMs);
    };

    const pause = () => {
      if (timer) clearInterval(timer);
      timer = null;
    };

    prevBtn?.addEventListener('click', () => go(current - 1));
    nextBtn?.addEventListener('click', () => go(current + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));

    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', play);

    root.addEventListener(
      'touchstart',
      (e) => {
        touchStartX = e.changedTouches[0].clientX;
        touchDeltaX = 0;
        pause();
      },
      { passive: true }
    );
    root.addEventListener(
      'touchmove',
      (e) => {
        touchDeltaX = e.changedTouches[0].clientX - touchStartX;
      },
      { passive: true }
    );
    root.addEventListener(
      'touchend',
      () => {
        const threshold = 48;
        if (touchDeltaX <= -threshold) go(current + 1);
        else if (touchDeltaX >= threshold) go(current - 1);
        else play();
        touchDeltaX = 0;
      },
      { passive: true }
    );

    play();
  }

  function boot() {
    document.querySelectorAll('.grefi-hero[data-autoplay]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);
})();
